import React, { useState } from "react";
import CheckoutInvoiceItem from "../CheckoutInvoiceItem";
import {
  Accordion,
  Icon,
  Transition,
  Divider,
  //,Button
} from "semantic-ui-react";
//import { Link } from "react-router-dom";
import "./styles.css";
import { connect } from "react-redux";
const ProductsAccordion = ({ cart }) => {
  const [activeIndex, setActiveIndex] = useState(true);
  const handleClick = () => {
    setActiveIndex(!activeIndex);
  };
  return (
    <Accordion styled>
      <Accordion.Title
        active={activeIndex}
        index={0}
        onClick={handleClick}
        className="checkout-accordion-title-container"
      >
        {cart.length === 1 ? (
          <span style={{ fontSize: 11 }}>
            Tienes un artículo en tu canasta de compras
          </span>
        ) : (
          cart &&
          cart.length >= 1 && (
            <span style={{ fontSize: 11 }}>
              Tienes {cart.length} artículos en tu canasta de compras
            </span>
          )
        )}
        <div className="float-right">
          {activeIndex ? (
            <Icon name="minus" size="small" />
          ) : (
            <Icon name="plus" size="small" />
          )}
        </div>
      </Accordion.Title>
      <Transition visible={activeIndex} animation="slide down" duration={500}>
        <Accordion.Content active={activeIndex}>
          <div className="checkout-accordion-content">
            {cart.map((product, index) => {
              return (
                <div key={index}>
                  <CheckoutInvoiceItem
                    title={product.name}
                    price={product.price}
                    quantity={product.quantity}
                    image={product.image}
                    code={product.code}
                  />
                  {index !== cart.length - 1 && <Divider />}
                </div>
              );
            })}
          </div>
          {/* <Divider />
          <div className="edit-cart-link-container">
            <Link to="/cart">
              <Button className="btn" size="tiny">
                Editar
              </Button>
            </Link>
          </div> */}
        </Accordion.Content>
      </Transition>
    </Accordion>
  );
};
const mapStateToProps = ({ cart }) => {
  return cart;
};
export default connect(mapStateToProps)(ProductsAccordion);
